<template>
    <a type="button" :href="link" :class="['btn btn-link cursor-pointer legitRipple', disabled ? 'disabled' : '' ]">
        {{ text }}
    </a>
</template>
<script>
export default {
    name: "LinkButton",
    props: {
        text: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
